import { AnyAction } from "redux";
import { SET_GROUPS_LOADED } from "../actions/loadingGroups";

export const loadingGroups = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_GROUPS_LOADED:
      return action.groupsLoaded;
    default:
      return state;
  }
};

export default loadingGroups;
